const ChooseAllSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <mask id="mask0_7443_26211" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7443_26211)">
        <path
          d="M6.73893 9.54463L11.1282 5.15537C11.2318 5.05179 11.3526 5 11.4907 5C11.6288 5 11.7497 5.05179 11.8533 5.15537C11.9568 5.25895 12.0086 5.38204 12.0086 5.52464C12.0086 5.66724 11.9568 5.79015 11.8533 5.89339L7.10147 10.6581C6.99788 10.7617 6.87704 10.8135 6.73893 10.8135C6.60082 10.8135 6.47998 10.7617 6.3764 10.6581L4.1494 8.43113C4.04581 8.32755 3.9961 8.20464 4.00024 8.06238C4.00438 7.92013 4.05842 7.79704 4.16234 7.69312C4.26627 7.58919 4.38936 7.5374 4.53161 7.53774C4.67386 7.53809 4.79678 7.58988 4.90036 7.69312L6.73893 9.54463Z"
          fill="#333333"
        />
      </g>
    </svg>
  );
};

export default ChooseAllSvg;
